import { StyleSheet, Text, View, type GestureResponderEvent } from 'react-native';
import { PrimaryButton } from 'src/presentation/components/molecules/Button';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import Fonts from 'src/core/utils/Fonts';
import Translations from 'src/core/utils/Translations';

interface ErrorViewProps {
	onPress: (event: GestureResponderEvent) => void;
}

function ErrorView({ onPress }: ErrorViewProps) {
	return (
		<View style={styles.container}>
			<Text style={styles.title}>{Translations.somethingWentWrongTitle}</Text>
			<Text style={styles.text}>{Translations.somethingWentWrongMessage}</Text>
			<PrimaryButton label={Translations.tryAgain} onPress={onPress} />
		</View>
	);
}

const styles = StyleSheet.create({
	container: {
		flex: Dimens.flex1,
		justifyContent: 'center',
		paddingHorizontal: Dimens.padding18,
	},
	title: {
		fontFamily: Fonts.ptSerif,
		fontSize: Dimens.fontSize20,
		lineHeight: Dimens.lineHeight30,
		color: Colors.gray900,
		marginBottom: Dimens.padding12,
		textAlign: 'center',
	},
	text: {
		fontFamily: Fonts.barlow,
		fontSize: Dimens.fontSize16,
		lineHeight: Dimens.lineHeight24,
		color: Colors.gray550,
		marginBottom: Dimens.padding30,
		textAlign: 'center',
	},
});

export default ErrorView;
